//ro-assist-brd1-5
export const OUTSIDE_BASE_PATH = "organizationInfo";
export const BASE_ADDRESS_PATH_1 = "prospect.organizationInfo.addressInfo[0]";
export const BASE_PATH_1 = "prospect.organizationInfo.addressInfo[0].addressDetails[0]";
export const BASE_PATH_2 = "prospect.organizationInfo.addressInfo[1].addressDetails[0]";

export const OTHER_OPTION_CODE = "6";

export const MAX_OFFICE_NUMBER_LENGTH = 10;
export const MAX_STREET_NUMBER_LENGTH = 50;
export const MAX_PO_BOX_NUMBER_LENGTH = 10;
export const MAX_OTHER_FIELD_LENGTH = 50;
export const MAX_FLAT_NUMBER_LENGTH = 50;
